import React from 'react';

class SkeleteLoading extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="skelete-loading">
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

export default SkeleteLoading;
